(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["about-us"]) return;
  try {
    




$(document).ready(function() {

//Sort random function
function random(owlSelector){
owlSelector.children().sort(function(){
return Math.round(Math.random()) - 0.5;
}).each(function(){
$(this).appendTo(owlSelector);
});
}

$("#test-car").owlCarousel({
navigation: true,
items : 1,
itemsCustom: false,
itemsDesktop: [1199, 1],
itemsDesktopSmall: [980, 1],
itemsTablet: [630, 1],
itemsTabletSmall: false,
itemsMobile: [479, 1],
navigationText: [
"<i class='fa fa-angle-left '></i>",
"<i class='fa fa-angle-right icon-white'></i>"
],
//Call beforeInit callback, elem parameter point to $("#owl-demo")
beforeInit : function(elem){
random(elem);
}

});

});






jQuery(document).ready(function() {

$(".inline").colorbox({inline:true, width:"50%"});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["client-logos"]) return;
  try {
    



$(document).ready(function() {
jQuery("#client-car").owlCarousel({   
       loop:true,
        margin:10,
        nav:false,       
        dots: true,
        responsive:{
            0:{
                items:1
            },
            600:{
                items:3
            },
            1000:{
                items:6
            }
        }
    });
  });





  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-model-3"]) return;
  try {
    

      if (jQuery.cookie('headerTop') == 'closed') {
        jQuery('.header-top').fadeOut();
      }

      jQuery('.header-top a.close').bind('click',function(){
        jQuery('.header-top').fadeOut();
        jQuery.cookie('headerTop', 'closed', {expires:-1, path:'/'});
      });  

jQuery(function($){ 
      function dropDown() {
        elementClick = '.header_toggle';
        elementSlide = '.header_slide_element';
        activeClass  = 'active';
        $(elementClick).on('click', function(e) {
          e.stopPropagation();
          var subUl = $(this).next(elementSlide);
          $(this).toggleClass(activeClass);

          $(elementClick).not(this).removeClass(activeClass);
          e.preventDefault();
        });
        $(document).on('click', elementSlide, function(e) {
          e.stopPropagation();
        });
        $(document).on('click', function(e) {
          e.stopPropagation();
          if (e.which != 3) {
            var elementHide = $(elementClick).next(elementSlide);
            // $(elementHide).hide();
            $(elementClick).removeClass('active');
          }
        });
      }
      dropDown()
    });
new UISearch( document.getElementById( 'sb-search' ) );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tab-model-2"] && !window.DesignMode) return;
  try {
    
$(document).ready(function() {
$("#tab").tabpager({
//  maximum visible items
// items: 7,
// CSS class for tabbed content
contents: 'contents',
// transition speed
time: 2000,
// initial tab
start: 1,
// top or bottom
position: 'top',
// scrollable
scroll: false
});
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-category"]) return;
  try {
    
$(document).ready(function(){
  $(".dt-menu-expand").click(function(event){
    event.preventDefault();
    if( $(this).hasClass("dt-mean-clicked") ){
      $(this).text("+");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideUp(400);
      } else {
        $(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
      }
    } else {
      $(this).text("-");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideDown(400);
      } else{
        $(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
      }
    }

    $(this).toggleClass("dt-mean-clicked");
    return false;
  });

});
      

  } catch(e) { console.error(e); }
})();

})();
